import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed } from "shared/lib/styles";

import { ContentItemHomeAroundMorningStudioPrimaryV2 } from "scmp-app/components/content/content-item-render/variants/home-around-morning-studio-primary-v2";
import { ContentItemHomeAroundMorningStudioSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-around-morning-studio-secondary-v2";
import { ContentItemHomeAroundPrimaryV2 } from "scmp-app/components/content/content-item-render/variants/home-around-primary-v2";
import { ContentItemHomeAroundSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-around-secondary-v2";

import ScmpLabLogo from "./scmp-lab-logo.svg";

export const StyledContentItemHomeAroundPrimaryV2 = styled(ContentItemHomeAroundPrimaryV2)``;
export const StyledContentItemHomeAroundSecondaryV2 = styled(ContentItemHomeAroundSecondaryV2)``;
export const StyledContentItemHomeAroundMorningStudioPrimaryV2 = styled(
  ContentItemHomeAroundMorningStudioPrimaryV2,
)``;
export const StyledContentItemHomeAroundMorningStudioSecondaryV2 = styled(
  ContentItemHomeAroundMorningStudioSecondaryV2,
)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled(BaseLink)`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;
`;

export const StyledScmpLabLogo = styled(ScmpLabLogo)``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  overflow: hidden;
`;

export const ItemDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;
